<template>
  <Layout :footer-style="2">
    <div class="InformationDetails" id="InformationDetails">
      <div class="InformationDetails_content">
        <StaticBanner :banner-date="bannerDate"></StaticBanner>
        <div class="content_body container">
          <div class="card_data">
            <div class="card_data_tit">来源：博信诚云</div>
            <div>发布时间：{{ newsDataType.createtime }}</div>
          </div>
          <div class="main_card">
            <div class="left_main" id="left_main">
              <div class="left_card">
                <div class="htmlData" v-html="newsDataType.content" ></div>
                <div class="fujian" v-if="textupload&&textupload.length!=0">
                  <span>附件：</span>
                  <ul>
                    <li v-for="(item,index) in textupload" :key="index"><a :href="item.response.file.url" download="item.response.file.name">{{item.response.file.name}}</a></li>
                  </ul>
                </div>
                <button
                  type="button"
                  class="btn btn-outline-primary text-primary backInformation"
                  @click="successCases"
                >
                  返回列表
                </button>
              </div>
              <div class="bgGray"></div>
              <div class="main-bottom">
                <div class="bottom-news">
                  <div class="pravCases" @click="textDataPrav()">
                    <span class="w-600">上一页：</span>
                    {{
                      dataPrav.title
                    }}
                  </div>
                  <div class="nextCases" @click="textDataNext()">
                    <span class="w-600">下一页：</span>
                    {{ dataNext.title }}
                  </div>
                </div>
              </div>
            </div>
            <div class="right_card" id="right_card">
              <div class="right_card_title w-700">博信诚，领先的智慧企业云平台服务商</div>
              <img class="SwipeImg" data-ind="index" :src="newsDataType.titleimage" />
              <swiper class="mySwipes" :options="swiperOption">
                <swiper-slide v-for="(item, index) in titleList" :key="index" class="swip">
                  <div class="Swipe_div">
                    <router-link :to="'/information-details/'+item.id">
                      <li>
                        <p style="overflow: hidden">{{ item.title }}</p>
                      </li>
                    </router-link>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
body {
  overflow: visible !important;
}
</style>
<style>
.activ {
  height: 200px;
}
.htmlData img{
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.fujian a{
  font-size: 16px;
}
</style>
<style lang="scss">
.InformationDetails {
  margin: 0 auto;
  max-width: 1920px;
  .InformationDetails_content {
    margin-top: 80px;
    background: #f7f7f7;
    .content_body {
      margin-top: -100px;
      .card_data {
        display: flex;
        position: relative;
        color: white;
        margin-bottom: 30px;
        padding: 0 20px;
        .card_data_tit {
          margin-right: 30px;
        }
      }
      .main_card {
        display: flex;
        justify-content: space-between;
        position: relative;
        padding-bottom: 3rem;
        &::after {
          content: "";
          display: block;
          overflow: hidden;
          clear: both;
        }
        .left_main {
          background: white;
          width: 70%;
          .left_card {
            padding: 30px 20px;
            /*.news-img {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              margin-bottom: 3rem;
            }
            .left-show {
              border: 1px solid rgb(165, 191, 234);
              padding: 3px;
              border-radius: 20px;
              margin: 1.5rem 0;
              .show-bg {
                background: rgb(255, 226, 226);
                border-radius: 20px;
              }
            }*/
          }
         /* .bar {
            background-color: #005bab;
            width: 24px;
            height: 5px;
            margin: 1rem 0;
          }
          .left-img {
            margin-bottom: 20px;
          }*/

          .backInformation {
            width: 12rem;
            height: 4rem;
            margin-right: 1rem;
            margin-top: 3rem;
            &:hover {
              background: #fff;
            }
          }

          .bgGray {
            width: 200%;
            height: 4rem;
            margin-left: -50%;
            background: #f7f7f7;
          }
          .main-bottom {
            border-top: 2px solid #005bab;
            .bottom-news {
              padding: 1rem;
              .pravCases,
              .nextCases {
                cursor: pointer;
                &:hover {
                  color: #059dff;
                }
              }
            }
          }
        }
        .right_card {
          max-width: 400px;
          background: white;
          padding: 15px 20px 0;
          overflow: hidden;
          width: 25%;
          height: 530px;
          padding-bottom: 15px;
          position: sticky;
          top: 80px;
          .right_card_title {
            height: 70px;
          }
          .right_card_list {
            a {
              &:hover {
                p {
                  color: #059dff;
                }
              }
            }
          }
          .Swipe_div {
            a {
              display: flex;
              justify-content: center;
              flex-wrap: wrap;
            }
          }
          .SwipeImg {
            width: 100%;
            //height: 33%;
            height: 170px;
          }
        }
        .mySwipes {
          height: calc(100% - 240px);
          margin-top: 1rem;
          .swiper-wrapper {
          }
        }
      }
    }
  }
}
</style>
<script>
import $ from 'jquery'
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
import Layout from "@/components/common/Layout"
import StaticBanner from "@/components/common/staticBanner/index.vue"
export default {
  name: "InformationDetails",
  components: { StaticBanner, Layout, swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        speed: 500,
        direction: "vertical",
        slidesPerView: 3,
        loop: true,
        autoplay: true,
        // observer: true,
        // observeParents: true,
      },
      bannerDate: {
        url: require("@/assets/images/aboutUs/InformationDetails-banner.png"),
        title: "博信诚荣获“2021中国企业上云数智化平台服务领军企业”",
        content: "",
        btn: false,
      },
      newsData:[],
      newsDataType:{},
      titleList:[],
      type: "",
      index:'',
      dataPrav:{},
      dataNext:{},
      textupload:[]
    }
  },
  watch: {
    $route() {
      location.reload()
      // this.type = this.$route.params.type
      // debugger
      // this.showData()
    },
  },
  mounted() {
    this.type = this.$route.params.type
    this.getDatass()
  },
  methods: {
    
    getDatass() {
      var ts = this
      $.ajax({
          type: "post",
          data: JSON.stringify({}),
          url: "http://120.53.104.103//bossint/findAllNewsPage/0/99999",
          dataType: "json",
          contentType: "application/json;charset=UTF-8",
          success: function (res) {
          // console.log(res)
          ts.newsData = res.content
          ts.newsData.map((item,index)=>{
            if(item.id == ts.type){
              ts.index=index
            }
          })
          ts.changeData(res.content)
          ts.showData()
          ts.changePage()
          },
          error: function () {
          // alert("出错啦...")
          },
      })
    },
    changeData(data){
        this.titleList = data.map((item,index)=>{
            return {title:item.title,id:item.id}
        })
    },
    showData() {
      this.bannerDate.title = this.newsData[this.index].title
      this.newsDataType = this.newsData[this.index]
      this.textupload = this.newsDataType.textupload
      console.log(this.newsDataType);
      if (this.textupload&&this.textupload.length!=0) {
        let text = this.newsDataType.textupload.split('*')
        console.log(text);
        this.textupload = text.map((item)=>{
          return item = JSON.parse(item)
        })
      }
      console.log(this.textupload);
    },
    successCases() {
      this.$router.push({
        path: "/information",
      })
    },
    changePage(){
      if (this.index == 0) {
        this.dataPrav = this.newsData[this.newsData.length - 1]
      } else {
        this.dataPrav = this.newsData[this.index-1]
      }
      if(this.index == this.newsData.length-1){
        this.dataNext = this.newsData[0]
      }else{
        this.dataNext = this.newsData[this.index+1]
      }
    },
    textDataPrav() {
      this.$router.push({
        path: "/information-details/" + this.dataPrav.id,
      })
    },
    textDataNext() {
      this.$router.push({
        path: "/information-details/" + this.dataNext.id,
      })
    },
  },
  destroyed() {
    let body = document.querySelector("body")
    body.style.overflow = "hidden"
  },
}
</script>
